// The roles Auth0 assigns. Mirrors the role constants in modules/broker/types.go,
// which the Go services check.
export const USER_ROLES = [
  "admin",
  "analyst",
  "agent",
  "broker",
  "consultant",
  "broker_analyst",
] as const;

export type UserRole = (typeof USER_ROLES)[number];

const SUPPORTED_ROLES: ReadonlySet<string> = new Set(USER_ROLES);

export const isUserRole = (value: unknown): value is UserRole =>
  typeof value === "string" && SUPPORTED_ROLES.has(value);
